var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-user-item__message",attrs:{"data-test":"no-user-item-message"}},[_c('el-card',[_vm._v("Aucun utilisateur")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }